import { jsx } from 'react/jsx-runtime';
import React, { useState, useEffect } from 'react';
import { DEFAULT_LOCALE, RTL_LANGUAGES, LOCALE_LABELS, LOCALE_COOKIE } from '../constants.esm.js';
import buildCookieDomainAttributeValue from '../utils/buildCookieDomainAttributeValue.esm.js';
import { detectLocale } from '../utils/detectLocale.esm.js';
import toBaseLocale from '../utils/toBaseLocale.esm.js';

const defaultLocalizationData = {
    defaultLocale: DEFAULT_LOCALE,
    currentLocale: DEFAULT_LOCALE,
    isRTL: RTL_LANGUAGES.includes(DEFAULT_LOCALE),
    localeLabels: LOCALE_LABELS,
    onChangeLocale: (locale)=>{
        document.cookie = `${LOCALE_COOKIE}=${locale}; path=/; domain=${buildCookieDomainAttributeValue(window?.location?.host)}`;
    },
    translations: []
};
const LocaleContext = /*#__PURE__*/ React.createContext(defaultLocalizationData);
const LocalizationProvider = (props)=>{
    const { children, data = {}, detectLocale: detectLocale$1 = true, detectTranslations = true, changeLocaleOnLoad = true, useBaseLocale = true } = props;
    const [detectedLocalizationData, setDetectedLocalizationData] = useState({
        currentLocale: DEFAULT_LOCALE,
        translations: []
    });
    const mergedData = {
        ...defaultLocalizationData,
        ...detectedLocalizationData,
        ...data
    };
    const normalizeLocale = (locale)=>useBaseLocale ? toBaseLocale(locale) : locale;
    const defaultLocale = normalizeLocale(mergedData.defaultLocale);
    const currentLocale = normalizeLocale(mergedData.currentLocale);
    const translations = (mergedData.translations || []).map((t)=>({
            ...t,
            locale: normalizeLocale(t.locale)
        }));
    useEffect(()=>{
        let detectedLocale = defaultLocale;
        if (detectLocale$1) {
            detectedLocale = detectLocale(document.location.pathname) ?? detectedLocale;
        }
        let detectedTranslations = [];
        if (detectTranslations) {
            detectedTranslations = Object.keys(window.mrTranslations || {}).reduce((acc, locale)=>{
                const a = document.createElement('a');
                a.href = window.mrTranslations[locale];
                acc.push({
                    locale: locale,
                    url: a.pathname || '/'
                });
                return acc;
            }, []);
        }
        if (detectLocale$1 || detectTranslations) {
            setDetectedLocalizationData({
                currentLocale: detectedLocale,
                translations: detectedTranslations
            });
        }
    }, [
        detectLocale$1,
        detectTranslations
    ]);
    useEffect(()=>{
        if (changeLocaleOnLoad && currentLocale !== defaultLocale) {
            mergedData.onChangeLocale(currentLocale);
        }
    }, [
        changeLocaleOnLoad
    ]);
    return jsx(LocaleContext.Provider, {
        value: {
            ...mergedData,
            defaultLocale,
            currentLocale,
            isRTL: RTL_LANGUAGES.includes(currentLocale),
            translations
        },
        children: children
    });
};

export { LocaleContext, LocalizationProvider as default };
